import type { RelativeCoordinate } from "@/model/coordinates";

import type { Line } from "./lineBreaker";

export interface PaintFunctions {
  fontSizeForOneLine: number;
  lineHeight: number;
  widthInCanvas: number;
  heightInCanvas: number;

  setCanvasFont(size: number): void;

  setElementFontSize(size: number): void;

  charsWidth(chars: string[], from: number, to: number): number;

  // display text lines on the canvas (for debugging reasons only)
  displayLines(x: number, y: number, text: string, lines: Line[]): void;
}

interface PaintLayer {
  init(el: SVGElement | HTMLElement, scale: RelativeCoordinate): PaintFunctions | null;
}

export let thePaintLayer: PaintLayer;

export function registerPaintLayer(paintLayer: PaintLayer) {
  thePaintLayer = paintLayer;
}
